import { render, staticRenderFns } from "./silicon.vue?vue&type=template&id=61e2c862&"
import script from "./silicon.vue?vue&type=script&lang=js&"
export * from "./silicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports